//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { CloseForUsersRequest } from './models/CloseForUsersRequest';
import type { CloseSubscriptionsRequest } from './models/CloseSubscriptionsRequest';
import type { CloseSubscriptionsResponse } from './models/CloseSubscriptionsResponse';
import { Utilities } from './Utilities';

export class CloseSubscriptionsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        closeForUsers: (): string => {
            let clientRequestUrl = '/api/v1/subscriptions';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        close: (): string => {
            let clientRequestUrl = '/api/v1/subscriptions/close';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        closeUnauthorized: (
			simulate?: boolean,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/close-unauthorized?';
            if (simulate === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('simulate'));
            } else if (simulate !== undefined) {
                clientRequestUrl += `simulate=${encodeURIComponent(String(simulate))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        closeProduct: (
			productId: number,
			deletedByIcId?: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/close/products/{productId}?';
            if (productId === undefined || productId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('productId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{productId}', encodeURIComponent(String(productId)));
            if (deletedByIcId === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('deletedByIcId'));
            } else if (deletedByIcId !== undefined) {
                clientRequestUrl += `deletedByIcId=${encodeURIComponent(String(deletedByIcId))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        closeKeyword: (
			keywordId: number,
			researchCategoryId: number,
			deletedByIcId?: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/close/keywords/{keywordId}/{researchCategoryId}?';
            if (keywordId === undefined || keywordId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('keywordId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{keywordId}', encodeURIComponent(String(keywordId)));
            if (researchCategoryId === undefined || researchCategoryId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('researchCategoryId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{researchCategoryId}', encodeURIComponent(String(researchCategoryId)));
            if (deletedByIcId === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('deletedByIcId'));
            } else if (deletedByIcId !== undefined) {
                clientRequestUrl += `deletedByIcId=${encodeURIComponent(String(deletedByIcId))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        closeResearchCategory: (
			researchCategoryId: number,
			deletedByIcId?: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/close/research-category/{researchCategoryId}?';
            if (researchCategoryId === undefined || researchCategoryId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('researchCategoryId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{researchCategoryId}', encodeURIComponent(String(researchCategoryId)));
            if (deletedByIcId === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('deletedByIcId'));
            } else if (deletedByIcId !== undefined) {
                clientRequestUrl += `deletedByIcId=${encodeURIComponent(String(deletedByIcId))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Close all subscriptions of users.
     * @param body (optional) List of IcId of the users on which to close subscriptions
     * @return No Content
     */
    async closeForUsers(
        body?: CloseForUsersRequest,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.closeForUsers();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Close subscriptions.
     * @param body (optional) The parameter to close subscriptions. For medium, possible values: email, notification, emailWithNotification.
     * @return OK
     */
    async close(
        body?: CloseSubscriptionsRequest,
    ): Promise<CloseSubscriptionsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.close();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<CloseSubscriptionsResponse>(_response, false, []);
    }

    /**
     * Close unauthorized subscriptions.
     * @param simulate (optional) 
     * @return No Content
     */
    async closeUnauthorized(
        simulate?: boolean,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.closeUnauthorized(
            simulate,
        );

        const options = {
            method: 'DELETE',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Close all subscriptions on provided product
     * @param productId Id of product to close subscriptions
     * @param deletedByIcId (optional) Force deleted by IC id else logged user IC id is used (Mainly useful for app2app tools)
     * @return No Content
     */
    async closeProduct(
        productId: number,
        deletedByIcId?: string,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.closeProduct(
            productId,
            deletedByIcId,
        );

        const options = {
            method: 'DELETE',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Close all subscriptions on provided keyword
     * @param keywordId Id of keyword to close subscriptions
     * @param researchCategoryId Research category of the keyword
     * @param deletedByIcId (optional) Force deleted by IC id else logged user IC id is used (Mainly useful for app2app tools)
     * @return No Content
     */
    async closeKeyword(
        keywordId: number,
        researchCategoryId: number,
        deletedByIcId?: string,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.closeKeyword(
            keywordId,
            researchCategoryId,
            deletedByIcId,
        );

        const options = {
            method: 'DELETE',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Close all subscriptions on provided research category that are not attached to a product
     * @param researchCategoryId Research category
     * @param deletedByIcId (optional) Force deleted by IC id else logged user IC id is used (Mainly useful for app2app tools)
     * @return No Content
     */
    async closeResearchCategory(
        researchCategoryId: number,
        deletedByIcId?: string,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.closeResearchCategory(
            researchCategoryId,
            deletedByIcId,
        );

        const options = {
            method: 'DELETE',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }
}
